export default __webpack_public_path__ + "/dist/images/3640469.png";